import { UserService } from 'src/services/users'
import { ApiError } from 'src/config/request'
import { MentionType } from 'src/utils/datahubDefaultEvent'
import { FetchMentionsParams, RequestState } from './useMentionUtils.types'

export class MentionService {
  static async fetchMentions({
    communityId,
    searchText,
    size,
    language,
    callback,
    onSuccess,
    onError
  }: FetchMentionsParams) {
    const emptyState = [{ id: 0, label: RequestState.NO_RESULTS }]

    try {
      const response = await UserService.find({
        communityId,
        searchText,
        size,
        language
      })

      const mentionList = response.results.map((result) => ({
        id: `@${MentionType.USER.toLowerCase()}#${result.ucode}`,
        type: MentionType.USER,
        label: result?.publicName || result?.name,
        reference: result.username,
        image: result.finalAvatar
      }))

      const isValidMentionList = Array.isArray(mentionList) && mentionList.length > 0
      const mentions = isValidMentionList ? mentionList : emptyState

      callback(mentions)
      onSuccess?.({
        query: searchText,
        length: mentionList.length
      })
    } catch (error) {
      callback([])
      onError?.({
        query: searchText,
        error: error as ApiError
      })
    }
  }
}
